module.exports = __webpack_public_path__ + "media/img/pages/companies/heig-vd-text-5b61c40ff0e3ef5eed354416a4e99bd2.png";